exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-storyblok-entry-full-slug-jsx": () => import("./../../../src/pages/{storyblokEntry.full_slug}.jsx" /* webpackChunkName: "component---src-pages-storyblok-entry-full-slug-jsx" */),
  "component---src-templates-property-template-jsx": () => import("./../../../src/templates/propertyTemplate.jsx" /* webpackChunkName: "component---src-templates-property-template-jsx" */)
}

